<template>
  <div class="choropleth">
    <svg width="100%" :height="height" ref="svg">
      <pattern id="lightgreen" width="6" height="6" patternUnits="userSpaceOnUse">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <rect width="6" height="6" fill="#d2e7c0"></rect>
          <polygon fill="#A5CE81" points="0 0 3 0 6 3 6 6"></polygon>
          <polygon fill="#A5CE81" points="0 3 3 6 0 6"></polygon>
        </g>
      </pattern>
      <pattern id="green" width="6" height="6" patternUnits="userSpaceOnUse">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <rect width="6" height="6" fill="#A5CE81"></rect>
          <polygon fill="#6FA746" points="0 0 3 0 6 3 6 6"></polygon>
          <polygon fill="#6FA746" points="0 3 3 6 0 6"></polygon>
        </g>
      </pattern>
      <g class="map">
        <path 
          v-for="polygon in polygons"
          :key="polygon.feature.id"
          class="polygon" 
          :d="polygon.path" 
          :fill="getFill(polygon)" 
          @mouseover="mouseover(polygon)" 
          @mouseleave="mouseleave()"
          ></path>
        <!-- <path v-for="polygon in polygons" class="polygon" :d="polygon.path" fill="url(#nodata)" @mouseover="mouseover(polygon)" @mouseleave="mouseleave()"></path> -->
        <path 
          v-if="selectedRegion != null || value != null" 
          class="polygon hover" 
          :d="hoverPath"
          ></path>
      </g>
      <g class="map">
        <path 
          v-for="polygon in BLpolygons"
          :key="polygon.feature.id"
          class="polygon bl" 
          :d="polygon.path"
          ></path>
        <path v-if="selectedRegion != null || value != null" class="polygon hover" :d="hoverPath"></path>
      </g>
    </svg>
    <svg class="legend" width="300" height="100" v-if="view === 'hotspots'">
      <text y="12" x="30" class="legend-label">Neuinfektionen pro 100.000 Einwohner</text>
      <text y="28" x="70" class="legend-label">in den letzten sieben Tagen</text>
      
      <!-- <rect :x="getX(0)" y="60" :width="getX(2)-getX(0)" height="20" fill="#6FA746"></rect> -->
      <!-- <rect :x="getX(0)" y="60" :width="getX(50)-getX(0)" height="20" fill="#c3deab"></rect> -->
      <!-- <rect :x="getX(2)" y="60" :width="getX(10)-getX(2)" height="20" fill="#8cb96b"></rect> -->
      <!-- <rect :x="getX(10)" y="60" :width="getX(35)-getX(10)"  height="20" fill="#c3deab"></rect> -->
      <rect :x="getX(0)" y="60" :width="getX(100)-getX(0)" height="20" fill="#EDBF57"></rect>
      <rect :x="getX(100)" y="60" :width="getX(250)-getX(100)" height="20" fill="#ED7D38"></rect>
      <rect :x="getX(250)" y="60" :width="getX(500)-getX(250)" height="20" fill="#D13D3D"></rect>
      <rect :x="getX(500)" y="60" :width="getX(1000)-getX(500)" height="20" fill="#9E1656"></rect>
      <rect :x="getX(1000)" y="60" :width="getX(2000)-getX(1000)" height="20" fill="#4A0643"></rect>
      <rect :x="getX(2000)" y="60" :width="getX(2000)-getX(500)" height="20" fill="#000000"></rect>

      <text :x="getX(1)" y="56" text-anchor="middle" class="legend-label scale">0</text>
      <!-- <text :x="getX(10)" y="56" text-anchor="middle" class="legend-label scale">10</text> -->
      <!-- <text :x="getX(35)" y="56" text-anchor="middle" class="legend-label scale">35</text> -->
      <!-- <text :x="getX(50)" y="56" text-anchor="middle" class="legend-label scale">50</text> -->
      <text :x="getX(250)" y="56" text-anchor="middle" class="legend-label scale">250</text>
      <text :x="getX(500)" y="56" text-anchor="middle" class="legend-label scale">500</text>
      <text :x="getX(1000)" y="56" text-anchor="middle" class="legend-label scale">1000</text>
      <text :x="getX(2000)" y="56" text-anchor="middle" class="legend-label scale">2000</text>

    </svg>
    <!-- <svg class="legend" width="300" height="78" v-if="view === 'new'">
      <text y="12" x="30" class="legend-label">Neuinfektionen pro 100.000 Einwohner</text>
      <text y="28" x="70" class="legend-label">in den letzten sieben Tagen</text>
      <g>
        <rect v-for="color in gradient" :x="color.x" y="36" :width="color.width" :height="8" :fill="color.fill"></rect>
        <g class="legend-labels" v-for="label in legendLabels" :transform="label.translate">
          <rect :x="label.x" y="36" width="1" :height="8" fill="#ddd"></rect>
          <text :y="64" class="legend-label">{{label.text}}</text>
        </g>
      </g>
    </svg>
    <svg class="legend" width="300" height="58" v-if="view === 'cumulated'">
      <text y="10" x="65" class="legend-label">Fälle pro 100.000 Einwohner</text>
      <g>
        <rect v-for="color in gradient" :x="color.x" y="18" :width="color.width" :height="8" :fill="color.fill"></rect>
        <g class="legend-labels" v-for="label in legendLabels" :transform="label.translate">
          <rect :x="label.x" y="18" width="1" :height="8" fill="#ddd"></rect>
          <text :y="46" class="legend-label">{{label.text}}</text>
        </g>
      </g>
    </svg> -->
  </div>
</template>

<script>
import * as d3 from 'd3'
import debounce from 'debounce'

d3.formatDefaultLocale({
  'decimal': ',',
  'thousands': '.',
  'grouping': [3],
  'currency': ['', '€'],
  'dateTime': '%a %b %e %X %Y',
  'date': '%d.%m.%Y',
  'time': '%H:%M:%S',
  'periods': ['AM', 'PM'],
  'days': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  'shortDays': ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  'months': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  'shortMonths': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
})

export default {
  name: 'choropleth-map',
  props: {
    map: Object,
    blmap: Object,
    domain: {
      type: Array,
      default () {
        return [0.9, 1.1]
      }
    },
    range: {
      type: Array,
      default () {
        return ['#182A35', '#80ED9F']
      }
    },
    selectedRegion: Object,
    view: String,
    maxHeight: {
      type: Number,
      default: 600
    },
    value: Object,
    showAverage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      projection: d3.geoMercator(),
      polygons: [],
      BLpolygons: [],
      height: this.maxHeight
    }
  },
  methods: {
    fitProjection () {
      let width = this.$refs.svg.getBoundingClientRect().width
      let height = this.maxHeight

      this.projection.scale(1).translate([0, 0])
      var b = this.path.bounds(this.map)
      var s = 1 / Math.max((b[1][0] - b[0][0]) / width, (b[1][1] - b[0][1]) / height)

      this.height = (b[1][1] - b[0][1]) * s

      var t = [(width - s * (b[1][0] + b[0][0])) / 2, (this.height - s * (b[1][1] + b[0][1])) / 2]

      this.projection
        .scale(s)
        .translate(t)

      this.polygons = this.map.features.map(f => {
        return {
          path: this.path(f),
          feature: f
        }
      })

      this.BLpolygons = this.blmap.features.map(f => {
        return {
          path: this.path(f),
          feature: f
        }
      })
    },
    getColor( value ) {
      return this.colorScale(value*12)
    },
    getFill (polygon) {
      if (this.view === "new") {
        if (polygon.feature.properties.cases7_per_100k == 0) {
          return 'url(#nodata)'
        } else {
          return this.colorScale(polygon.feature.properties.cases7_per_100k*12)
        }
      } else if (this.view === 'hotspots') {
        if (polygon.feature.properties.cases7_per_100k >= 2000) {
          return '#000'
        } else if (polygon.feature.properties.cases7_per_100k >= 1000) {
          return '#4A0643'
        } else if (polygon.feature.properties.cases7_per_100k >= 500) {
          return '#9E1656'
        } else if (polygon.feature.properties.cases7_per_100k >= 250) {
          return '#D13D3D'
        } else if (polygon.feature.properties.cases7_per_100k >= 100) {
          return '#ED7D38'
        } else if (polygon.feature.properties.cases7_per_100k >= 50){
          return '#EDBF57'
        } else if (polygon.feature.properties.cases7_per_100k >= 25){
          return '#c3deab' //'url(#lightgreen)'
        } else if (polygon.feature.properties.cases7_per_100k == 0){
          if (polygon.feature.properties.OBJECTID == 351) {
            return '#ddd'
          } else {
            return '#c3deab' //'url(#lightgreen)'
          }
        } else {
          return '#8cb96b' //'url(#green)'
        }
      } else {
        return this.colorScale(polygon.feature.properties.cases_per_100k)
      }
    },
    // getY (val) {
    //   let x = scaleLinear()
    //     .domain(this.type == 'bar' ? this.yRangeComputed : this.yRange)
    //     .range([this.height, this.padding.top])
    //   return x(val)
    // },
    getX (val) {
      const x = d3.scaleLinear()
        .domain([0, 2500])
        .range([10, 290])
      return x(val)
    },
    mouseover (polygon) {
      let centroid = this.path.centroid(polygon.feature)

      this.$emit('input', {
        OBJECTID: polygon.feature.properties.OBJECTID,
        name: polygon.feature.properties.GEN,
        cases_per_100k: String(Math.round(parseFloat(polygon.feature.properties.cases_per_100k)*100)/100).replace('.',','),
        cases7_per_100k: String(Math.round(parseFloat(polygon.feature.properties.cases7_per_100k)*100)/100).replace('.',','),
        cases: polygon.feature.properties.cases,
        deaths: polygon.feature.properties.deaths,
        x: Math.round(centroid[0]),
        y: Math.round(centroid[1])
      })
    },
    mouseleave () {
      this.$emit('input', null)
    }
  },
  mounted () {
    this.fitProjection()
    window.addEventListener('resize', debounce(this.fitProjection, 250))
  },
  watch: {
  },
  computed: {
    path () {
      return d3.geoPath().projection(this.projection)
    },
    colorScale () {
      return d3.scaleLinear().domain(this.domain).range(this.range)
      // return d3.scaleLinear().domain(this.category.domain || this.domain).range(this.category.colorRange || this.range)
    },
    hoverPath () {
      // if (this.value == null) return null
      if (this.value != null && this.value != 42) {
        return this.polygons.find(p => p.feature.properties.OBJECTID === this.value.OBJECTID).path
      } else {
        return this.polygons.find(p => p.feature.properties.OBJECTID == this.selectedRegion.FID).path
      }
    },
    gradient () {
      let steps = 11
      let firstStep = this.domain[0]
      let lastStep = this.domain.slice(-1)[0]
      let stepSize = (lastStep - firstStep) / steps

      return '.'.repeat(steps).split('').map((d, i) => {
        let value = firstStep + (stepSize * i)
        // value = Math.pow(value, 2)
        return {
          fill: this.colorScale(value*3),
          x: 16 + (i / steps) * (300 - 32),
          width: (300 - 32) / steps
        }
      })
    },
    legendLabels () {
      if(this.view != 'cumulated') {
        return [{
          translate: 'translate(16, 0)',
          text: '0'
        }, {
          translate: `translate(${300 - 16}, 0)`,
          text: 50
        }]
      } else {
        return [{
          translate: 'translate(16, 0)',
          text: '0'
        }, {
          translate: `translate(${300 - 16}, 0)`,
          text: this.domain[2]*3
        }]
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.choropleth {
  box-sizing: border-box;

  .legend {
    margin-top: 16px;
    left: 50%;
    transform: translateX(-50%);
    position: relative;

    .legend-label {
      font-family: 'FAZ Gold', Helvetica, Arial, sans-serif;
      // text-anchor: start;
      font-size: 14px;

      &.scale {
        color: #666;
        // letter-spacing: -.05em;
        font-size: 12px;
      }
    }
  }

  .legend-labels:last-of-type .legend-label {
    // text-anchor: end;
  }

  .map {
    .polygon {
      stroke: rgba(255,255,255,.5);
      stroke-width: 0.5;

      &.bl {
        stroke: #fff;
        stroke-width: 1;
        fill: transparent;
        pointer-events: none;
        stroke-linejoin: round;
      }

      &.hover {
        stroke-width: 1.5;
        stroke: #000;
        stroke-linejoin: round;
        fill: none;
      }
    }
  }
}
</style>
